export default __webpack_public_path__ + "static/embla-logo-light-theme-blur-db7093b8d7d20cb8c2429e3f6e05156a.svg";